import React, { useEffect, useState } from "react";

// Libraries
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { m } from "framer-motion";
import { Parallax } from 'react-scroll-parallax'

// Components
import Buttons from "../../Components/Button/Buttons";
import StoryWide from "../../Components/Story/StoryWide";
import { fadeIn ,fadeInUp,zoomIn} from "../../Functions/GlobalAnimations";

import Overlap from '../../Components/Overlap/Overlap'
import Tab03 from '../../Components/Tab/Tab03'
import { TabData03 } from '../../Components/Tab/TabData'

// Data
import slide_2 from "../../Assets/img/home-restaurant-bg-01.jpg"
import slide_6_1 from "../../Assets/img/home-restaurant-img-13.jpg"
import slide_6_2 from "../../Assets/img/img-14.jpg"
import slide_6_3 from "../../Assets/img/img-15.webp"
import axios from "axios";
import config from "../../config";

const SwiperData = [
  {
    img: "/img/1.webp",
    title: "des solutions de qualité",
    subtitle: "SPEED TUNISIA",
  },
  {
    img: "/img/2.jpeg",
    title: "Services Process Equiopements",
    subtitle: "EXPRESS-Distribution",
  },
  {
  img: "/img/3.jpg",
  title: "Cuisine authentique",
  subtitle: "Saveurs exceptionnelles"
  }
]

const FashionShopPage = (props) => {
  const swiperRef = React.useRef(null);

  const pagination = {
    clickable: true,
    el: ".custom-pagination",
    renderBullet: function (index, className) {
      return `<span class="${className}">0${index + 1}</span>`;
    },
  };
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.REACT_APP_API_URL}/productsGroupedByCategory`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
        setData(response.data.result);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <div style={props.style}>

      {/* Section Start */}
      <section>
        <Swiper
          className="slider-nav-dark white-move swiper-pagination-light swiper-pagination-medium h-full min-md:h-[920px] min-sm:h-[450px]"
          modules={[Pagination, Autoplay]}
          pagination={false}
          ref={swiperRef}
          slidesPerView={1}
          spaceBetween={0}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
        >
          {
            SwiperData.map((item, i) => {
              return (
                <SwiperSlide key={i} style={{ backgroundImage: `url(${item.img})` }} className="bg-no-repeat	bg-cover	overflow-hidden relative bg-center">
                  <div className="absolute h-full w-full top-0 left-0 opacity-50 bg-[#23232391]"></div>
                  <Container className="full-screen sm:h-[450px]">
                    <Row className="h-full justify-center min-md:h-[920px] min-sm:h-[450px]">
                      <Col xl={6} sm={7} className="text-center h-full justify-center flex-col relative flex">
                        <span className="font-serif tracking-[3px] text-xxl text-white font-bold uppercase block mb-[45px] sm:mb-[15px]">{item.subtitle}</span>
                        <h1 className="font-serif font-bold text-shadow-extra-large text-[80px] leading-[95px] text-white uppercase tracking-[-4px] mb-[55px] mx-auto sm:mx-0 lg:text-[90px] lg:leading-[90px] md:text-[70px] md:leading-[65px] sm:text-[25px] sm:leading-[43px] sm:tracking-[-1px] sm:mb-[30px] xs:w-[85%]">{item.title}</h1>
                        <div className="inline-block">
                          <Buttons ariaLabel="Discover more" href="#" className="btn-fill btn-fancy drop-shadow-md font-medium font-serif uppercase rounded-[2px] btn-shadow text-[15px] md:mb-[15px]" size="lg" themeColor="#cd9452" color="#fff" title="Discover more" />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </section>
      {/* Section End */}

      {/* Section Start */}
      <m.section {...fadeIn} id="about" className="pt-[9%] pb-[384px] md:pb-[200px] sm:pb-[7%] xs:pt-32 xs:pb-35 restaurant-experience" style={{ background: `url(${slide_2}) center top no-repeat, right top 140px no-repeat` }}>
        <Container>
          <Row className="items-center xs:text-center">
            <Col lg={2} className="md:mb-[25px]">
              <m.img width={150} height={149} className="w-[auto] xs:mx-auto" {...{ ...zoomIn, transition: { duration: 0.8 } }} src="/img/home-restaurant-img-01.webp" alt="vegetables" />
            </Col>
            <Col xl={4} lg={5} sm={7} className="md:mb-[20px]">
              <m.h2 {...{ ...fadeIn, transition: { delay: 0.4 } }} className="heading-5 font-serif font-medium text-darkgray mb-0 -tracking-[1px]">Des matières premières qui inspirent vos recettes, nourrissent vos marques, et séduisent vos clients.</m.h2>
            </Col>
            <Col lg={5} md={7} sm={8} className="pl-24 lg:pl-[15px]">
              <m.div {...{ ...fadeIn, transition: { delay: 0.8 } }}>
                <p className="mb-[20px]">SPEED Tunisia est votre partenaire de confiance dans la distribution agroalimentaire, spécialisée dans les produits de biscuiterie, la charcuterie et les produits laitiers. Nous mettons la réactivité, la qualité et la fiabilité au cœur de notre engagement pour répondre aux besoins des professionnels du secteur.</p>
                <Buttons to="/apropos" className="font-medium font-serif uppercase btn-link after:h-[2px] hover:text-black md:text-md md:mb-[15px] after:bg-darkgray" size="xl" color="#232323" title="À Propos" />
              </m.div>
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Section End */}

      {/* Overlap Section Start */}
      <section className="bg-[#f8f4f0] pb-[130px] xl:pb-[90px] lg:pb-[75px] sm:py-[50px]">
        <Container fluid className="mb-20">
          <Row className="justify-center">
            <Overlap>
              <Col xs={12} className="text-center relative">
                <m.img width={1459} height={500} {...{ ...zoomIn, transition: { duration: 0.8 } }} className="w-full m-auto" src="/img/home-restaurant-bg-02.webp" alt="" />
              </Col>
            </Overlap>
          </Row>
        </Container>
        <Container>
          <m.div {...fadeIn} className="justify-center row">
            <Col lg={4} md={6} className="text-center mb-[4.5rem] md:mb-16 sm:mb-12">
              <div className="flex flex-row items-center justify-center text-center mb-[5px]">
                <span className="w-[25px] h-[1px] bg-[#ca943d] opacity-40"></span>
                <div className="font-serif text-xmd text-[#ca943d] px-[10px]">NOS CATÉGORIÉ</div>
                <span className="w-[25px] h-[1px] bg-[#ca943d] opacity-40"></span>
              </div>
              <h2 className="heading-5 font-serif font-semibold text-darkgray uppercase -tracking-[1px] sm:mb-[15px]">Produits pour Tous Vos Besoins</h2>
            </Col>
          </m.div>
          <m.div className="row xs:justify-center restaurant-tab-style-03" {...fadeIn}>
            <Tab03 data={data} />
          </m.div>
        </Container>
      </section>
      {/* Overlap Section End */}

      {/* Section Start */}
      <section className="py-[130px] overflow-hidden lg:py-[90px] md:py-[75px] sm:py-[50px]">
        <Container>
          <Row className="justify-center">
            <Col lg={4} md={6} className="text-center mb-[4.5rem] md:mb-16 sm:mb-12">
              <div className="flex flex-row items-center justify-center text-center mb-[5px]">
                <span className="w-[25px] h-[1px] bg-[#ca943d] opacity-40"></span>
                <div className="font-serif text-xmd text-[#ca943d] px-[10px]">NOS SPECIALITÉ</div>
                <span className="w-[25px] h-[1px] bg-[#ca943d] opacity-40"></span>
              </div>
              <h2 className="heading-5 font-serif font-semibold text-darkgray uppercase -tracking-[1px] sm:mb-[15px]">NOUS OFFRONS LES MEILLEUR SERVICES</h2>
            </Col>
          </Row>
          <Row className="row-cols-1 row-cols-lg-4 row-cols-md-2 justify-center">
            <m.div {...{ ...fadeIn, transition: { delay: 0.2 } }} className="col text-center interactive-banners-style-11 md:mb-[50px] sm:mb-[30px]">
              <figure className="rounded-[6px] overflow-hidden relative">
                <img width={360} height={258} className="w-full" src="/img/pngegg.png" alt="Dishes" />
                <figcaption>
                  <div className="opacity-70 top-0 left-0 absolute w-full h-full bg-darkgray"></div>
                  <div className="flex flex-col items-center justify-center h-full">
                    <Link aria-label="link" to="#" className=" z-[1] p-6 text-xmd leading-[20px] rounded-none w-[110px] h-[110px] uppercase font-serif text-white flex flex-col justify-center"><span className="font-semibold text-darkgray -tracking-[.5px]"></span></Link>
                  </div>
                </figcaption>
              </figure>
              <div className="text-center mt-[40px] sm:mt-[20px]">
                <span className="text-darkgray font-medium font-serif block text-golden-hover uppercase">INDUSTRIE LAITIERE</span>
              </div>
            </m.div>
            <m.div {...{ ...fadeIn, transition: { delay: 0.4 } }} className="col text-center interactive-banners-style-11 md:mb-[50px] sm:mb-[30px]">
              <figure className="rounded-[6px] overflow-hidden relative">
                <img width={360} height={258} className="w-full" src="/img/pngegg-1.png" alt="Dishes" />
                <figcaption>
                  <div className="opacity-70 top-0 left-0 absolute w-full h-full bg-darkgray"></div>
                  <div className="flex flex-col items-center justify-center h-full">
                    <Link aria-label="link" to="#" className="z-[1] p-6 text-xmd leading-[20px] rounded-none w-[110px] h-[110px] uppercase font-serif text-white flex flex-col justify-center"><span className="font-semibold text-darkgray -tracking-[.5px]"></span></Link>
                  </div>
                </figcaption>
              </figure>
              <div className="text-center mt-[40px] sm:mt-[20px]">
                <span className="text-darkgray font-medium font-serif block text-golden-hover uppercase">INDUSTRIE DES VIANDES</span>
              </div>
            </m.div>
            <m.div {...{ ...fadeIn, transition: { delay: 0.6 } }} className="col text-center interactive-banners-style-11 md:mb-[50px] sm:mb-[30px]">
              <figure className="rounded-[6px] overflow-hidden relative">
                <img width={360} height={258} className="w-full" src="/img/patisserie-1.png" alt="Dishes" />
                <figcaption>
                  <div className="opacity-70 top-0 left-0 absolute w-full h-full bg-darkgray"></div>
                  <div className="flex flex-col items-center justify-center h-full">
                    <Link aria-label="link" to="#" className=" z-[1] p-6 text-xmd leading-[20px] rounded-none w-[110px] h-[110px] uppercase font-serif text-white flex flex-col justify-center"><span className="font-semibold text-darkgray -tracking-[.5px]"></span></Link>
                  </div>
                </figcaption>
              </figure>
              <div className="text-center mt-[40px] sm:mt-[20px]">
                <span className="text-darkgray font-medium font-serif block text-golden-hover uppercase">PATISSERIE ET BOULANGERIE</span>
              </div>
            </m.div>
            <m.div {...{ ...fadeIn, transition: { delay: 0.6 } }} className="col text-center interactive-banners-style-11 md:mb-[50px] sm:mb-[30px]">
              <figure className="rounded-[6px] overflow-hidden relative">
                <img width={360} height={258} className="w-full" src="/img/sauce1-1.png" alt="Dishes" />
                <figcaption>
                  <div className="opacity-70 top-0 left-0 absolute w-full h-full bg-darkgray"></div>
                  <div className="flex flex-col items-center justify-center h-full">
                    <Link aria-label="link" to="#" className=" z-[1] p-6 text-xmd leading-[20px] rounded-none w-[110px] h-[110px] uppercase font-serif text-white flex flex-col justify-center"><span className="font-semibold text-darkgray -tracking-[.5px]"></span></Link>
                  </div>
                </figcaption>
              </figure>
              <div className="text-center mt-[40px] sm:mt-[20px]">
                <span className="text-darkgray font-medium font-serif block text-golden-hover uppercase">INDUSTRIE DES SAUCES</span>
              </div>
            </m.div>
          </Row>
        </Container>
      </section>
      {/* Section End */}
      
      {/* Section Start */}
      <section className="p-0 pb-5 overflow-hidden">
        <Container fluid className="px-0">
          <Row className="gx-0">
            <Col xl={6} className="p-0">
              <m.div {...fadeIn} className="block flex flex-column flex-md-row h-full">
                <Col md={6} className="cover-background sm:h-[700px]" style={{ backgroundImage: `url(${slide_6_1})` }}></Col>
                <Col md={6} className="bg-[#f8f4f0] flex flex-col justify-center text-start px-12 xl:px-[15px] lg:p-20 md:px-[2.5rem]">
                  <img width={57} height={40} src="/assets/img/webp/home-restaurant-img-transparent-05.webp" className="self-start mb-[20px]" alt="" />
                  <h2 className="heading-4 font-serif font-light text-darkgray -tracking-[1px] w-[85%] mb-12 xs:w-full xs:mb-[15px]"> <span className="font-semibold">message</span></h2>
                  <p className="w-[75%] xs:w-full">Bénéficiez de l’expertise de nos ingénieurs agroalimentaires, à votre écoute pour vous guider et vous conseiller dans chaque secteur d’activité que nous desservons.</p>
                </Col>
              </m.div>
            </Col>
            <Col xl={6} className="p-0">
              <Row className="g-0">
                <Col xs={{ order: 1 }} sm={{ span: 6, order: 1 }} className="p-0">
                  <m.div {...fadeIn} className="text-center px-24 py-32 xl:py-24 xl:px-16 lg:px-28 sm:px-24 bg-darkgray">
                    <span className="font-serif font-medium text-[#ca943d] tracking-[1px] text-md block uppercase mb-[20px]">Produits Sélectionnés</span>
                    <h6 className="font-serif text-white mb-0">Des Produits sélectionnés pour répondre à vos exigences professionnelle</h6>
                  </m.div>
                </Col>
                <m.div {...{ ...fadeIn, transition: { delay: 0.2 } }} className="col-12 col-sm-6 order-2 cover-background xs:h-[300px]" style={{ backgroundImage: `url(${slide_6_3})` }}></m.div>
                <m.div {...{ ...fadeIn, transition: { delay: 0.4 } }} className="col-12 col-sm-6 order-4 order-sm-3 px-0 cover-background xs:h-[300px]" style={{ backgroundImage: `url(${slide_6_2})` }}></m.div>
                <Col xs={{ order: 2 }} sm={{ span: 6, order: 4 }}>
                  <m.div {...{ ...fadeIn, transition: { delay: 0.6 } }} className="text-center px-24 py-32 xl:py-24 xl:px-16 lg:px-28 sm:px-24">
                    <span className="font-serif font-medium text-[#ca943d] tracking-[1px] text-md block uppercase mb-[20px]">Fournisseur Fiables</span>
                    <h6 className="font-serif text-darkgray mb-0">Fournisseur Fiables pour l'industrie agroalimentaire en Tunisie</h6>
                  </m.div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Section End */}
    </div>
  );
};

export default FashionShopPage;
